export const checkMessageInState = (state: any) => {
  if (state)
    return {
      title: state.title ?? '',
      message: state.message ?? '',
    };

  return null;
};
